export default () => ({
  list: [],
})
